export default "__VITE_ASSET__5cf53e95__"